// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/drift-illusions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/drift-illusions/drift-illusions.js';

mount([g0]);
